import dbData from '../db/db.json';

export const useGlobalData = () => dbData;